<template>
  <div>
    <div
      v-show="success != ''"
      class="notice success"
    >
      <span>{{ success }}</span>
      <BBtn
        text
        position="right"
        class="close"
      >
        <BIcon
          class="px-200"
          size="small"
          type="white"
          @click="success = ''"
        >
          close
        </BIcon>
      </BBtn>
    </div>
    <div
      v-show="error != ''"
      class="notice error"
    >
      <span>{{ error }}</span>
      <BBtn
        text
        position="right"
        class="close"
      >
        <BIcon
          class="px-200"
          size="small"
          type="white"
          @click="error = ''"
        >
          close
        </BIcon>
      </BBtn>
    </div>
    <div
      v-loading="salesforceSettingLoading"
      class="content"
    >
      <div class="pl-600 pb-200 target-object-name">
        {{ $t(`sfObjectMappings.${selectedObject}`) }}
      </div>
      <div
        v-show="selectedObject == 'opportunity'"
        class="mb-100 py-200 px-600"
      >
        <div class="record-type-title">
          {{ $t(`opportunityRecordType.title`) }}
        </div>
        <BSelect
          v-model="salesforceRecordTypeId"
          filterable
          class="select-column selectbox"
          :items="opportunityRecordTypes"
          item-text="name"
          item-value="id"
          fit
          required
        />
      </div>
      <div
        v-show="innerColumnList"
        class="modal-tab-box"
      >
        <div class="tab-header">
          <div
            v-for="(objectName, currentTab) in innerColumnList"
            :key="currentTab"
            class="tab-item"
            :class="{ active: isCurrentTab(currentTab) }"
            @click="() => setSelectTab(currentTab, objectName)"
          >
            <span>{{ $t(`import.salesforce.mappings.${currentTab}`) }}</span>
          </div>
        </div>
      </div>
      <BLayout
        class="pl-600 pb-200 header"
        justify-center
        align-center
      >
        <BListItem
          v-show="useChangeImport"
          class="column-content non-border radio-priority-area"
        >
          <span>SF優先</span>
        </BListItem>
        <BListItem
          class="column-content non-border"
        >
          <span>Salesforce項目</span>
        </BListItem>
        <div class="icon" />
        <BListItem
          v-show="useChangeImport"
          class="column-content non-border radio-priority-area"
        >
          <span>BC優先</span>
        </BListItem>
        <BListItem
          class="column-content non-border"
        >
          <span>BALES CLOUD項目</span>
        </BListItem>
        <BListItem
          v-show="useChangeImport"
          class="column-content non-border check-area"
        >
          <span>SF→BC</span>
        </BListItem>
        <BListItem
          v-show="useChangeImport"
          class="column-content non-border check-area"
        >
          <span>SF←BC</span>
        </BListItem>
      </BLayout>
      <BLayout
        v-for="(value, bcKey) in mapping"
        :key="`${bcKey}-${changeBoxCounter}`"
        class="pl-600 pb-200"
        justify-center
        align-center
      >
        <BListItem
          v-show="useChangeImport"
          class="radio-priority-area"
        >
          <div
            v-show="sharedObjectMapping[bcKey] == null"
            :class="`column-content non-border radio-box
              radio-box-${value['bc_priority'] != true && value['sf_import'] ? 'active' : 'non-active'}`"
            @click="() => changePriority('sf_import', bcKey)"
          >
            <BIcon
              class="radio"
              size="b-icon-small"
            >
              done
            </BIcon>
          </div>
        </BListItem>
        <BListItem>
          <div
            v-if="value['lock']"
            class="column-content non-border select-column"
          >
            {{ sfFieldsMap[value['sf_column']] }}
          </div>
          <BSelect
            v-else
            v-model="sfFieldsMap[value['sf_column']]"
            filterable
            clearable
            class="select-column"
            :items="selectItems(bcKey)"
            item-text="label"
            item-value="value"
            fit
            :disabled="sharedObjectMapping[bcKey] != null"
            :placeholder="sharedObjectMapping[bcKey] == null ? $t('general.select.please') : $t('sfObjectMappings.alreadyUsed')"
            @clear="() => reset(bcKey)"
            @change="changed"
          >
            <template #optionTemplate="{ item }">
              <span
                class="b-select"
                :class="{'b-selected': item['value']['sfKey'] && value['sf_column'] == item['value']['sfKey']}"
              >
                {{ item['label'] }}
              </span>
            </template>
          </BSelect>
        </BListItem>
        <div class="icon">
          <BIcon
            class="icon-sync"
            size="b-icon-medium"
          >
            swap_horiz
          </BIcon>
        </div>
        <BListItem
          v-show="useChangeImport"
          class="radio-priority-area"
        >
          <div
            v-show="!('sf_import_only' in value && value['sf_import_only'] == true) && sharedObjectMapping[bcKey] == null"
            :class="`column-content non-border radio-box
              radio-box-${value['bc_priority'] ? 'active' : 'non-active'}`"
            @click="() => changePriority('bc_import', bcKey)"
          >
            <BIcon
              class="radio"
              size="b-icon-small"
            >
              done
            </BIcon>
          </div>
        </BListItem>
        <BListItem>
          <div
            class="column-content non-border bc-label"
          >
            <span v-if="customFieldsMap[bcKey] != null">
              {{ customFieldsMap[bcKey]['name'] }}
            </span>
            <span v-else-if="customActionsMap[bcKey] != null">
              {{ customActionsMap[bcKey]['name'] }}
            </span>
            <span v-else-if="value['label'] != null">
              {{ value['label'] }}
            </span>
            <span v-else>
              {{ $t(`import.salesforce.mappings.${bcKey}`) }}
            </span>
          </div>
        </BListItem>
        <BListItem
          v-show="useChangeImport"
          class="check-area"
        >
          <BCheckbox
            v-show="sharedObjectMapping[bcKey] == null"
            v-model="value['sf_import']"
            class="column-content non-border check-box"
            :disabled="value['sync_force']"
            @change="() => changeSyncMode('sf_import', bcKey)"
          />
        </BListItem>
        <BListItem
          v-show="useChangeImport"
          class="check-area"
        >
          <BCheckbox
            v-show="!('sf_import_only' in value && value['sf_import_only'] == true) && sharedObjectMapping[bcKey] == null"
            v-model="value['bc_import']"
            class="column-content non-border check-box"
            :disabled="value['sync_force']"
            @change="() => changeSyncMode('bc_import', bcKey)"
          />
        </BListItem>
      </BLayout>
    </div>
    <div class="footer">
      <div
        class="btn-back"
        @click="backAction"
      >
        {{ $t("sfObjectMappings.back") }}
      </div>
      <div
        class="btn-save"
        @click="confirmModal"
      >
        {{ $t("sfObjectMappings.save") }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { SfObjectMappingService } from '@/api/user/resources/salesforce/sf_object_mapping';
import { useConfirmWithOptions } from '@/composable/message-dialog';
import { i18nGlobal as i18n } from '@/i18n';

type TProps = {
  selectedObject?: string;
};
type TItem = {
  label: string;
  value: {
    bcKey: string;
    sfKey: string;
    dataType: string;
    updateable: boolean
  };
};

const props = withDefaults(defineProps<TProps>(), {
  selectedObject: '',
});
const emit = defineEmits(['back']);
const api = new SfObjectMappingService();
const mapping = ref({});
const sfFields = ref({});
const sfFieldsMap = ref({});
const sfMapInfo = ref({});
const sfColumnDataTypes = ref({});
const customFieldsDataTypes = ref({});
const sharedObjectMapping = ref({});
const innerColumnList = ref({});
const customFieldsMap = ref({});
const customActionsMap = ref({});
const opportunityRecordTypes = ref([]);
const useChangeImport = ref(false);
const currentTab = ref('');
const salesforceSettingLoading = ref(true);
const success = ref('');
const error = ref('');
// v-forで選択したときに、同一のkeyの場合に書き換わらないケースががあるため
const changeBoxCounter = ref(0);
const isChanged = ref(false);
const salesforceRecordTypeId = ref<string | null>(null);

const { confirmWithOptions } = useConfirmWithOptions();

const backAction = () => {
  emit('back');
};

const reset = (key: string) => {
  mapping.value[key].sf_column = '';
  // 変更が反映されないことがあるため、v-forのkeyを更新
  changeBoxCounter.value++;
};

const changed = (item: TItem['value'] | undefined) => {
  // clearのときもchangedが動くのでitemが空になったときは返す
  if (item == null) {
    return;
  }
  success.value = '';
  error.value = '';
  // 変更があったかチェック
  isChanged.value = mapping.value[item.bcKey].sf_column != item.sfKey;
  // selectItemsのvalueが帰ってくる
  mapping.value[item.bcKey].sf_column = item.sfKey;
  if (item.updateable && mapping.value[item.bcKey].sf_import_only_lock != true) {
    mapping.value[item.bcKey].sf_import_only = false;
  } else {
    mapping.value[item.bcKey].sf_import_only = true;
    mapping.value[item.bcKey].bc_import = false;

  }
  // 実装上の都合で選択されたものの値がsfFieldsMapと異なるフォーマットで更新されてしまうので、
  // データ更新後にリストを初期化しなおす
  loadSfFieldsMap();
  // 変更が反映されないことがあるため、v-forのkeyを更新
  changeBoxCounter.value++;
};

const selectItems = (bcKey): TItem[] => {
  const sfKeys = Object.values(mapping.value).map((v) => {
    return v.sf_column;
  });
  let mapDataType = sfColumnDataTypes.value[bcKey] ?? 'string';
  if (bcKey.indexOf('custom') === 0) {
    mapDataType = customFieldsDataTypes.value[mapping.value[bcKey].data_type] ?? 'string';
  }
  if (bcKey.indexOf('opportunity_custom') === 0) {
    mapDataType = customFieldsDataTypes.value[mapping.value[bcKey].data_type] ?? 'string';
  }
  let selectFilterItems;
  if (mapDataType === 'string') {
    // DataTypeがstringの場合は全てのデータタイプの選択肢を統合
    selectFilterItems = {};
    for (const dataType of Object.keys(sfMapInfo.value)) {
      Object.assign(selectFilterItems, sfMapInfo.value[dataType]);
    }
  } else {
    selectFilterItems = sfMapInfo.value[mapDataType];
  }
  if (selectFilterItems == null || Object.keys(selectFilterItems).length === 0) {
    return [];
  }
  const sfMap = [];
  for (const sfKey of Object.keys(selectFilterItems)) {
    // {'Company': {'label': '会社名', 'data_type': 'string'}}を{label: '会社名', options: 'Company', data_type: 'string'}のように変換
    if (sfKey !== 'Id'
      && (!sfKeys.includes(sfKey) || mapping.value[bcKey].sf_column === sfKey)
    ) {
      sfMap.push({ label: selectFilterItems[sfKey].sf_label, value: { bcKey, sfKey, dataType: selectFilterItems[sfKey].data_type, updateable: selectFilterItems[sfKey].updateable } });
    }
  }
  return sfMap;
};

const loadSfFieldsMap = () => {
  const sfMap = [];
  for (const sfKey of Object.keys(sfFields.value)) {
    if (sfKey !== 'Id') {
      sfMap[sfKey] = sfFields.value[sfKey].label;
    }
  }
  sfFieldsMap.value = sfMap;
};

const upsertMapping = async () => {
  salesforceSettingLoading.value = true;
  api.upsertSfObjectMappingBody(
    {
      upsertSfObjectMappingBodyRequest: {
        targetObject: props.selectedObject,
        mapping: JSON.stringify(mapping.value),
        salesforceRecordTypeId: salesforceRecordTypeId.value,
      },
    },
  ).then(() => {
    success.value = i18n.t('general.success.to', { action: i18n.t('general.update.text') });
  }).catch((e) => {
    if (e.response && e.response.data.errorMessage) {
      error.value = `${i18n.t('general.fail.to', { action: i18n.t('general.update.text') })} ${e.response.data.errorMessage}`;
    } else {
      error.value = i18n.t('general.fail.to', { action: i18n.t('general.update.text') });
    }
  });
  salesforceSettingLoading.value = false;
};

const syncMapping = async () => {
  salesforceSettingLoading.value = true;
  api.syncSfObjectMapping();
  syncCheck();
};

const syncCheck = async () => {
  const syncCheckInterval = setInterval(async () => {
    const sync = await api.checkSyncSfObjectMapping();
    if (sync.data.sync == false) {
      clearInterval(syncCheckInterval);
      salesforceSettingLoading.value = false;
      success.value = i18n.t('general.success.to', { action: i18n.t('general.update.text') });
    }
  }, 1000);
};

const changeSyncMode = (target, bcKey) => {
  // importがfalseの場合はpriorityの設定を見直す
  if (
    target === 'bc_import'
    && mapping.value[bcKey][target] == false
  ) {
    mapping.value[bcKey].bc_priority = false;
  } else if (
    target === 'bc_import'
    && mapping.value[bcKey][target] == true
    && mapping.value[bcKey].sf_import == false
  ) {
    mapping.value[bcKey].bc_priority = true;
  } else if (
    target === 'sf_import'
    && mapping.value[bcKey].sf_import == false
    && mapping.value[bcKey].bc_import == true
  ) {
    mapping.value[bcKey].bc_priority = true;
  }
};

const changePriority = (targetImport, bcKey) => {
  // 対象のimportがtrueじゃなければ変えない
  if (!mapping.value[bcKey][targetImport]) return;

  if (targetImport === 'bc_import') {
    mapping.value[bcKey].bc_priority = true;
  } else if (targetImport === 'sf_import') {
    mapping.value[bcKey].bc_priority = false;
  }
};

const isCurrentTab = (tab) => {
  return currentTab.value == tab;
};

const setSelectTab = (tab, objectName) => {
  currentTab.value = tab;
  changeCurrentTab(objectName);
};

const changeCurrentTab = (objectName) => {
  Object.keys(mapping.value).forEach((key) => {
    mapping.value[key].bc_object = objectName;
  });
};

const confirmModal = async () => {
  if (props.selectedObject == 'opportunity'
    && salesforceRecordTypeId.value == null
  ) {
    error.value = i18n.t('general.fail.to', { action: i18n.t('opportunityRecordType.alert.required') });
    salesforceSettingLoading.value = false;
    return;
  }
  // 項目の追加、変更がない場合はmappingの更新をかけるだけ
  let optionalButtonOptions = {
    'edit': {
      text: i18n.t('sfObjectMappings.confirm.edit'),
      value: 'edit',
      className: 'swal-button--optional',
    },
    'submit': {
      text: i18n.t('sfObjectMappings.confirm.sync'),
      value: 'update',
    },
  };
  if (isChanged.value) {
    // 項目の追加、変更があった場合は即時反映
    optionalButtonOptions = {
      'edit': {
        text: i18n.t('sfObjectMappings.confirm.edit'),
        value: 'edit',
        className: 'swal-button--optional',
      },
      'submit': {
        text: i18n.t('sfObjectMappings.confirm.sync'),
        value: 'sync',
      },
    };
  }
  const completing = await confirmWithOptions({
    title: i18n.t('sfObjectMappings.confirm.title'),
    message: i18n.t('sfObjectMappings.confirm.desc'),
    optionalButtonOptions,
  });
  if (completing === 'sync') {
    await upsertMapping();
    syncMapping();
    isChanged.value = false;
  } else if (completing === 'update') {
    upsertMapping();
  }
};

onMounted(async () => {
  const result = await api.getSfObjectMappings({ targetObject: props.selectedObject });
  mapping.value = result.data.sfObjectMappings.objectMappings;
  sfFields.value = result.data.sfObjectMappings.objectFields;
  sfMapInfo.value = result.data.sfObjectMappings.sfMapInfo;
  sfColumnDataTypes.value = result.data.sfObjectMappings.sfColumnDataTypes;
  customFieldsDataTypes.value = result.data.sfObjectMappings.customFieldsDataTypes;
  sharedObjectMapping.value = result.data.sfObjectMappings.sharedObjectMapping;
  innerColumnList.value = result.data.sfObjectMappings.innerColumnList;
  customFieldsMap.value = result.data.sfObjectMappings.customFieldsMap ?? {};
  customActionsMap.value = result.data.sfObjectMappings.customActionsMap ?? {};
  salesforceRecordTypeId.value = result.data.sfObjectMappings.salesforceRecordTypeId;
  opportunityRecordTypes.value = result.data.sfObjectMappings.opportunityRecordTypes ?? [];

  // 空を許容したくないので、指定がないなら詰めておく
  if (opportunityRecordTypes.value.length > 0 && salesforceRecordTypeId.value == undefined) {
    salesforceRecordTypeId.value = opportunityRecordTypes.value[0].id;
  }

  useChangeImport.value = innerColumnList.value == null;
  if (innerColumnList.value != null) {
    currentTab.value = Object.keys(innerColumnList.value)[0];
    changeCurrentTab(innerColumnList.value[currentTab.value]);
  }
  loadSfFieldsMap();
  salesforceSettingLoading.value = false;

  // sync中だったら操作できないようにする
  const sync = await api.checkSyncSfObjectMapping();
  if (sync.data.sync) {
    salesforceSettingLoading.value = true;
    syncCheck();
  }
});
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: auto;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 290px;
}

.object-name {
  font-weight: bold;
}

.column-content {
  width: 100%;
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  border: 1px solid #E3E3E3;
}

.bc-label {
  overflow-y: scroll;
}

.select-column {
  width: 100%;

  &.selectbox {
    width: 42%;
  }
}

.non-border {
  border-width: 0;
}

.icon {
  display: flex;
  width: 20%;
  align-items: center;
  justify-content: center;
  font-size: 32px !important;
  color: $concrete-dark !important;
  padding: 0 12px;

  .icon-sync {
    color: $concrete-dark !important;
  }
}

.hr {
  border-bottom: 1px solid $bdcolor-base;
  margin-bottom: 8px;
}

.footer {
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100% - 310px);
  height: 63px;
  background-color: #F6F6F6;;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-back {
  color: #231815;
  font-size: 18px;
  margin: 0 12px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.btn-save {
  width: 101px;
  height: 37px;
  border-radius: 4px;
  background: #018485;
  margin: 0 12px;
  color: #FFF;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.btn-sync {
  width: 112px;
  height: 37px;
  border-radius: 4px;
  background: #FF8749;
  margin: 0 12px;
  color: #FFF;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.notice {
  position: relative;
  width: 100%;
  height: 60px;
  padding: 12px 0;
  margin: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
}

.close {
  position: absolute;
  right: 0;
}

.success {
  background-color: $basecolor-success;
}

.error {
  background-color: $basecolor-error;
}

.header {
  color: $concrete-dark;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}

.target-object-name {
  font-weight: bold;
  font-size: 20px;
}

.check-area {
  width: 80px !important;
  margin: 0 20px;
  flex-shrink: 0;
  text-align: center;
}

.radio-priority-area {
  width: 60px !important;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  text-align: center;
}

.check-box {
  --el-checkbox-input-height: 20px;
  --el-checkbox-input-width: 20px;
  --el-checkbox-border-radius: 4px;
  --el-index-normal: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;

  :deep(.el-checkbox__input) {
    .el-checkbox__inner::after{
      width: 9px;
      height: 10px;
      border: 2px solid transparent;
      border-left: 0;
      border-top: 0;
      border-color: var(--el-checkbox-checked-icon-color);
      transform: rotate(45deg) scaleY(1);
      top: 0;
      left: 22%;
    }
  }

  > .check {
    color: $textcolor-white;
  }

  &.check-box-active {
    background-color: $basecolor-success;
  }

  &.check-box-non-active {
    background-color: $concrete-dark;
  }
}

.radio-box {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  border-radius: 50%;

  > .radio {
    color: $textcolor-white;
  }

  &.radio-box-active {
    background-color: $basecolor-success;
  }

  &.radio-box-non-active {
    background-color: $concrete-dark;
  }
}

.b-select {
  color: #231815;
  font-weight: normal;
}
.b-selected {
  color: var(--el-color-primary);
  font-weight: bold;
}

.modal-tab-box {
  margin: $basespace-200 0;

  .tab-header {
    height: 23px;
    border-bottom: 1px solid $bdcolor-base;

    .tab-item {
      margin: 0 $basespace-600;
      position: relative;
      top: 1px;
      transition: $transition-base;
      font-size: $fontsize-200;
      line-height: 1;
      text-align: center;
      padding: 0 0 6px;
      color: $textcolor-base;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      font-weight: 600;
      min-width: 56px;
      width: fit-content;

      &:hover {
        color: $basecolor-primary;
      }

      &.active {
        color: $basecolor-primary;
        border-color: $basecolor-primary;
      }
    }
  }
}

.record-type-title {
  color: $textcolor-light;
  margin-bottom: 8px;
}
</style>
